export default function Refunds() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h1>Cancellation & Refund Policy</h1>

      <p>
        ORIVON TECHNOLOGIES believes in helping its customers as far as possible,
        and has therefore a liberal cancellation policy.
      </p>

      <p>
        Cancellations will be considered only if the request is made within
        <strong> 1–2 days</strong> of placing the order. However, the cancellation
        request may not be entertained if the orders have been communicated to the
        vendors/merchants and they have initiated the process of shipping them.
      </p>

      <p>
        KRISHH JAGDISH LOHAR does not accept cancellation requests for perishable
        items like flowers, eatables, etc. However, refund/replacement can be made
        if the customer establishes that the quality of the product delivered is
        not good.
      </p>

      <p>
        In case of receipt of damaged or defective items, please report the same
        to our Customer Service team within <strong>1–2 days</strong> of receipt.
        The request will be entertained only after merchant verification.
      </p>

      <p>
        If you feel the product received is not as shown on the site or as per
        expectations, please notify our customer service within 1–2 days.
      </p>

      <p>
        In case of approved refunds, it will take <strong>9–15 days</strong> for
        the amount to be processed to the end customer.
      </p>
    </div>
  );
}
